import { render, staticRenderFns } from "./ProblematicAccountModal.vue?vue&type=template&id=6e895c5d&scoped=true&"
import script from "./ProblematicAccountModal.vue?vue&type=script&lang=js&"
export * from "./ProblematicAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./ProblematicAccountModal.vue?vue&type=style&index=0&id=6e895c5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e895c5d",
  null
  
)

export default component.exports